import React from 'react';
import ReactHtmlParser from 'react-html-parser'
import {cl,globs,constant} from '../../components/utils/utils';

class GroupPopup extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      mounted:false,
      opacity:0,
      fading:false,
      showPopup:true,
    }
  }
  
  componentDidMount=()=>{
    this.mounted=true
  }
  
  componentWillUnmount=()=>{
    this.mounted=false
  }
  
  mySetState=(state)=>{
    if(this.mounted){this.setState(state)}
  }
  
  onChange=(type,vals)=>{
    switch(type){
      case "popup":
        if(this.props.onClose){this.props.onClose()}
        break
    }
  }
  
  doFading=()=>{
    let step=0.01
    let diff=(this.props.open?1:0)-this.state.opacity
    if (Math.abs(diff)<step){
      this.mySetState({fading:false, opacity:(this.props.open?1:0)})
    }else{
      let op=this.state.opacity
      if(diff>0){
        op+=step
      }else{
        op-=step
      }
      this.mySetState({opacity:op})
      setTimeout(this.doFading,80)
    }
  }
  
  render(){
    let diff=(this.props.open?1:0)-this.state.opacity
    if(diff){setTimeout(this.doFading,1)}
    var ch
    if(Array.isArray(this.props.content)){
      ch=<p>{this.props.content}</p>
    }else{
      ch=<div>{this.props.content.split('\n').map( (it, i) => <div key={'x'+i}>{it}</div> )}</div>
    }
    return(
      <>
        <div id="popup" className="popup" style={{
          opacity: this.state.opacity,
          display:(this.state.opacity!=0)?"block":"none"}}>
          <h3>{this.props.title}</h3>
          {ch}
          <br />
          <div className="alignright">
            <button id="popupButton" type="button" className="outlined left-margin"
              onClick={e=>this.onChange("popup")}
            >Close</button>
          </div>
        </div>
        <div className="popup-scrim" style={{display:(this.state.opacity!=0)?"block":"none"}}></div>
      </>
    )
  }
}
      
export default GroupPopup;